import { render, staticRenderFns } from "./DeploymentUserPermissions.vue?vue&type=template&id=77532eac&"
import script from "./DeploymentUserPermissions.vue?vue&type=script&lang=js&"
export * from "./DeploymentUserPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports